module.exports = __webpack_public_path__ + "static/media/PDF_37.fd8939e6.pdf";